import { z } from 'zod';
import { $CandidateRegion } from './CandidateRegion';

export const $CandidateCity = z.object({
  id: z.number(),
  name: z.string(),
  region: $CandidateRegion,
});
